import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {FieldInputComponent} from './field-input.component';
import {AmountInputModule} from '../../amount/amount-input/amount-input.module';
import {NumberInputModule} from '../../number/number-input/number-input.module';
import {FormFieldModule} from '../../../../modules/core/component/form-field/form-field.module';
import {SelectFilterModule} from '../../select-filter/select-filter.module';
import {MultipleSelectFilterModule} from '../../../../modules/core/component/multiple-select-filter/multiple-select-filter.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {DatePickerModule} from '../../date-picker/date-picker.module';
import {DateTimePickerModule} from '../../datetime-picker/date-time-picker.module';
import {CheckboxInputModule} from '../../checkbox/checkbox-input/checkbox-input.module';
import {YesNoInputModule} from '../../yes-no/yes-no-input/yes-no-input.module';
import {RadioButtonGroupInputModule} from '../../radio-button-group/radio-button-group-input/radio-button-group-input.module';
import {CheckboxGroupInputModule} from '../../checkbox-group/checkbox-group-input/checkbox-group-input.module';
import {LoadingModule} from '../../loading/loading.module';
import {InputTextModule} from '../../../../modules/core/component/input-text/input-text.module';
import {RichTextEditorModule} from '../../rich-text-editor/rich-text-editor.module';
import {
    EmbeddedImageFieldInputTypeHandlerModule
} from './type-handlers/embedded-image-field-input-type-handler-component/embedded-image-field-input-type-handler.module';
import {FieldInputTypeHandlerRegister} from './type-handler/IFieldInputTypeHandler';
import {
    FormDefinitionFieldSubType,
    FormDefinitionFieldType
} from '../../../../modules/form/definition/field/api/entity/formDefinitionFieldSummary.model';
import {
    EmbeddedImageFieldInputTypeHandlerComponent
} from './type-handlers/embedded-image-field-input-type-handler-component/embedded-image-field-input-type-handler.component';
import {
    SelectManyFieldInputTypeHandlerComponent
} from './type-handlers/select-many-field-input-type-handler/select-many-field-input-type-handler.component';
import {
    SelectManyFieldInputTypeHandlerModule
} from './type-handlers/select-many-field-input-type-handler/select-many-field-input-type-handler.module';
import {
    DrawableImageFieldInputTypeHandlerComponent
} from './type-handlers/drawable-image/v1/drawable-image-field-input-type-handler/drawable-image-field-input-type-handler.component';
import {
    DrawableImageFieldInputTypeHandlerModule
} from './type-handlers/drawable-image/v1/drawable-image-field-input-type-handler/drawable-image-field-input-type-handler.module';
import {
    DocumentPdfFieldInputTypeHandlerModule
} from './type-handlers/document-pdf-field-input-type-handler/document-pdf-field-input-type-handler.module';
import {
    DocumentPdfFieldInputTypeHandlerComponent
} from './type-handlers/document-pdf-field-input-type-handler/document-pdf-field-input-type-handler.component';
import {ButtonModule} from "../../../../modules/core/component/button/button.module";
import {MatBadgeModule} from "@angular/material/badge";
import {FieldInputCommentDialogComponent} from "../field-input-comment-dialog/field-input-comment-dialog.component";
import {
    DrawableImageV2FieldInputTypeHandlerComponent
} from "./type-handlers/drawable-image/v2/drawable-image-v2-field-input-type-handler/drawable-image-v2-field-input-type-handler.component";
import {
    DrawableImageV2EmbeddedFileFieldInputTypeHandlerComponent
} from "./type-handlers/drawable-image/v2/drawable-image-v2-embedded-file-field-input-type-handler/drawable-image-v2-embedded-file-field-input-type-handler.component";
import {
    VideoAnalysisFieldInputTypeHandlerComponent
} from "./type-handlers/video-analysis-field-input-type-handler/video-analysis-field-input-type-handler.component";
import {
    MaterializePlateExamStaticFieldInputHandlerComponent
} from "../../../../modules/medical/materialize/impl/component/materialize-plate-exam-static-field-input-handler/materialize-plate-exam-static-field-input-handler.component";
import {
    MaterializePlateExamDynamicFieldInputHandlerComponent
} from "../../../../modules/medical/materialize/impl/component/materialize-plate-exam-dynamic-field-input-handler/materialize-plate-exam-dynamic-field-input-handler.component";
import {TablerIconsModule} from "angular-tabler-icons";
import {MatTooltipModule} from "@angular/material/tooltip";
import {SelectFilterV2Component} from "../../select-filter-v2/select-filter-v2.component";
import {ChipsComponent} from "../../../../modules/core/component/chips/chips.component";
import {InputTextareaModule} from "../../../../modules/core/component/input-textarea/input-textarea.module";
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        ReactiveFormsModule,
        AmountInputModule,
        NumberInputModule,
        FormFieldModule,
        SelectFilterModule,
        MultipleSelectFilterModule,
        DatePickerModule,
        DateTimePickerModule,
        CheckboxInputModule,
        YesNoInputModule,
        RadioButtonGroupInputModule,
        CheckboxGroupInputModule,
        LoadingModule,
        InputTextModule,
        RichTextEditorModule,
        EmbeddedImageFieldInputTypeHandlerModule,
        DocumentPdfFieldInputTypeHandlerModule,
        SelectManyFieldInputTypeHandlerModule,
        DrawableImageFieldInputTypeHandlerModule,
        DrawableImageV2FieldInputTypeHandlerComponent,
        DrawableImageV2EmbeddedFileFieldInputTypeHandlerComponent,
        VideoAnalysisFieldInputTypeHandlerComponent,
        ButtonModule,
        MatBadgeModule,
        FieldInputCommentDialogComponent,
        TablerIconsModule,
        MatTooltipModule,
        SelectFilterV2Component,
        ChipsComponent,
        InputTextareaModule,
    ],
    declarations: [
        FieldInputComponent,
    ],
    exports: [
        FieldInputComponent,
    ],
})
export class FieldInputModule {
    constructor() {
        FieldInputTypeHandlerRegister.register(EmbeddedImageFieldInputTypeHandlerComponent,
            FormDefinitionFieldType.FORM_DEFINITION_FIELD_TYPE_EMBEDDED_FILE,
            FormDefinitionFieldSubType.FORM_DEFINITION_FIELD_SUBTYPE_IMAGE);

        FieldInputTypeHandlerRegister.register(EmbeddedImageFieldInputTypeHandlerComponent,
            FormDefinitionFieldType.FORM_DEFINITION_FIELD_TYPE_DOCUMENT,
            FormDefinitionFieldSubType.FORM_DEFINITION_FIELD_SUBTYPE_IMAGE);

        FieldInputTypeHandlerRegister.register(SelectManyFieldInputTypeHandlerComponent,
            FormDefinitionFieldType.FORM_DEFINITION_FIELD_TYPE_CHOICE,
            FormDefinitionFieldSubType.FORM_DEFINITION_FIELD_SUBTYPE_SELECT_MANY);

        FieldInputTypeHandlerRegister.register(DrawableImageFieldInputTypeHandlerComponent,
            FormDefinitionFieldType.FORM_DEFINITION_FIELD_TYPE_DRAWABLE_IMAGE,
            undefined);

        FieldInputTypeHandlerRegister.register(DrawableImageV2FieldInputTypeHandlerComponent,
            FormDefinitionFieldType.FORM_DEFINITION_FIELD_TYPE_DRAWABLE_IMAGE_V2,
            undefined);
        FieldInputTypeHandlerRegister.register(DrawableImageV2EmbeddedFileFieldInputTypeHandlerComponent,
            FormDefinitionFieldType.FORM_DEFINITION_FIELD_TYPE_DRAWABLE_IMAGE_V2,
            FormDefinitionFieldSubType.FORM_DEFINITION_FIELD_SUBTYPE_EMBEDDED_FILE);

        FieldInputTypeHandlerRegister.register(VideoAnalysisFieldInputTypeHandlerComponent,
            FormDefinitionFieldType.FORM_DEFINITION_FIELD_TYPE_VIDEO_ANALYSIS, undefined);

        FieldInputTypeHandlerRegister.register(DocumentPdfFieldInputTypeHandlerComponent,
            FormDefinitionFieldType.FORM_DEFINITION_FIELD_TYPE_DOCUMENT,
            FormDefinitionFieldSubType.FORM_DEFINITION_FIELD_SUBTYPE_PDF);

        FieldInputTypeHandlerRegister.register(MaterializePlateExamStaticFieldInputHandlerComponent,
            FormDefinitionFieldType.FORM_DEFINITION_FIELD_TYPE_JSON,
            'FORM_DEFINITION_FIELD_SUBTYPE_STATIC_PLATE_ANALYSIS');

        FieldInputTypeHandlerRegister.register(MaterializePlateExamDynamicFieldInputHandlerComponent,
            FormDefinitionFieldType.FORM_DEFINITION_FIELD_TYPE_JSON,
            'FORM_DEFINITION_FIELD_SUBTYPE_DYNAMIC_PLATE_ANALYSIS');
    }
}
